/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Button,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  Modal,
  ModalBody,
} from "reactstrap";

const APP_BASE_RAW = process.env.PUBLIC_URL || "";
const APP_BASE =
  APP_BASE_RAW && APP_BASE_RAW !== "/" ? APP_BASE_RAW.replace(/\/+$/, "") : "";

const ADMIN_HEADER_BANNER_ITEMS = [
  {
    src: `${APP_BASE}/banners/banner-1.jpeg`,
    altText: "Karadeniz Destanları - Banner 1",
    key: "banner-1",
  },
  {
    src: `${APP_BASE}/banners/banner-2.jpeg`,
    altText: "Karadeniz Destanları - Banner 2",
    key: "banner-2",
  },
  {
    src: `${APP_BASE}/banners/banner-3.jpeg`,
    altText: "Karadeniz Destanları - Banner 3",
    key: "banner-3",
  },
  {
    src: `${APP_BASE}/banners/banner-4.jpeg`,
    altText: "Karadeniz Destanları - Banner 4",
    key: "banner-4",
  },
  {
    src: `${APP_BASE}/banners/banner-5.jpeg`,
    altText: "Karadeniz Destanları - Banner 5",
    key: "banner-5",
  },
  {
    src: `${APP_BASE}/banners/banner-6.jpeg`,
    altText: "Karadeniz Destanları - Banner 6",
    key: "banner-6",
  },
  {
    src: `${APP_BASE}/banners/banner-7.jpeg`,
    altText: "Karadeniz Destanları - Banner 7",
    key: "banner-7",
  },
  {
    src: `${APP_BASE}/banners/banner-8.jpeg`,
    altText: "Karadeniz Destanları - Banner 8",
    key: "banner-8",
  },
];

const Header = ({
  stats = { total: 0, withImage: 0, withAudio: 0, withVideo: 0 },
  activeFilter = "all",
  onFilterChange,
}) => {
  const [activeBannerIndex, setActiveBannerIndex] = React.useState(0);
  const [isBannerAnimating, setIsBannerAnimating] = React.useState(false);
  const [isBannerPreviewOpen, setIsBannerPreviewOpen] = React.useState(false);
  const [bannerPreviewItem, setBannerPreviewItem] = React.useState(
    ADMIN_HEADER_BANNER_ITEMS[0]
  );

  const openBannerPreview = (item) => {
    setBannerPreviewItem(item);
    setIsBannerPreviewOpen(true);
  };

  const setFilter = (next) => {
    if (typeof onFilterChange === "function") onFilterChange(next);
  };

  const onSharePage = async () => {
    const url = "https://efsaneler.karadenizdestinasyonu.com.tr/";
    const title = "Karadeniz Efsaneleri";

    try {
      if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
        await navigator.share({ title, url });
        return;
      }
    } catch {
      // Share dialog cancelled or failed; continue to fallbacks.
    }

    try {
      if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        alert("Link kopyalandı.");
        return;
      }
    } catch {
      // ignore
    }

    try {
      window.prompt("Bağlantıyı kopyalayın:", url);
    } catch {
      try {
        window.location.assign(url);
      } catch {
        // ignore
      }
    }
  };

  const nextBanner = () => {
    if (isBannerAnimating) return;
    setActiveBannerIndex((prev) =>
      prev === ADMIN_HEADER_BANNER_ITEMS.length - 1 ? 0 : prev + 1
    );
  };

  const prevBanner = () => {
    if (isBannerAnimating) return;
    setActiveBannerIndex((prev) =>
      prev === 0 ? ADMIN_HEADER_BANNER_ITEMS.length - 1 : prev - 1
    );
  };

  const goToBanner = (index) => {
    if (isBannerAnimating) return;
    setActiveBannerIndex(index);
  };

  return (
    <>
      <div className="header bg-gradient-info pb-5 pb-md-8 pt-4 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {}
            <Row>
              <Col xs="6" sm="6" lg="6" xl="3" className="d-flex">
                <Card
                  className="card-stats mb-3 mb-xl-0 flex-fill"
                  role="button"
                  tabIndex={0}
                  onClick={() => setFilter("all")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") setFilter("all");
                  }}
                  title="Toplam (filtreyi kaldır)"
                  style={{ cursor: "pointer" }}
                  aria-pressed={String(activeFilter || "all") === "all"}
                >
                  <CardBody className="py-3 px-3">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <CardTitle
                          tag="h6"
                          className="text-uppercase text-dark mb-1 text-truncate"
                        >
                          Toplam
                        </CardTitle>
                        <span className="h3 font-weight-bold mb-0 d-block text-truncate">
                          {stats.total}
                        </span>
                      </div>
                      <div className="ml-auto flex-shrink-0" style={{ marginRight: -6 }}>
                        <div
                          className="icon icon-shape bg-danger text-white rounded-circle shadow d-flex align-items-center justify-content-center"
                          style={{ width: 42, height: 42 }}
                        >
                          <i className="ni ni-book-bookmark" />
                        </div>
                      </div>
                    </div>
                    <p className="mt-2 mb-0 text-dark text-sm">
                      <span className="text-nowrap">Kayıtlı efsane sayısı</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col xs="6" sm="6" lg="6" xl="3" className="d-flex">
                <Card
                  className="card-stats mb-3 mb-xl-0 flex-fill"
                  role="button"
                  tabIndex={0}
                  onClick={() => setFilter("image")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") setFilter("image");
                  }}
                  title="Görselli içerikleri filtrele"
                  style={{ cursor: "pointer" }}
                  aria-pressed={String(activeFilter || "all") === "image"}
                >
                  <CardBody className="py-3 px-3">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <CardTitle
                          tag="h6"
                          className="text-uppercase text-dark mb-1 text-truncate"
                        >
                          Görselli
                        </CardTitle>
                        <span className="h3 font-weight-bold mb-0 d-block text-truncate">
                          {stats.withImage}
                        </span>
                      </div>
                      <div className="ml-auto flex-shrink-0" style={{ marginRight: -6 }}>
                        <div
                          className="icon icon-shape bg-success text-white rounded-circle shadow d-flex align-items-center justify-content-center"
                          style={{ width: 42, height: 42 }}
                        >
                          <i className="ni ni-image" />
                        </div>
                      </div>
                    </div>
                    <p className="mt-2 mb-0 text-dark text-sm">
                      <span className="text-nowrap">Görsel yüklenen</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col xs="6" sm="6" lg="6" xl="3" className="d-flex">
                <Card
                  className="card-stats mb-3 mb-xl-0 flex-fill"
                  role="button"
                  tabIndex={0}
                  onClick={() => setFilter("audio")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") setFilter("audio");
                  }}
                  title="Sesli içerikleri filtrele"
                  style={{ cursor: "pointer" }}
                  aria-pressed={String(activeFilter || "all") === "audio"}
                >
                  <CardBody className="py-3 px-3">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <CardTitle
                          tag="h6"
                          className="text-uppercase text-dark mb-1 text-truncate"
                        >
                          Sesli
                        </CardTitle>
                        <span className="h3 font-weight-bold mb-0 d-block text-truncate">
                          {stats.withAudio}
                        </span>
                      </div>
                      <div className="ml-auto flex-shrink-0" style={{ marginRight: -6 }}>
                        <div
                          className="icon icon-shape bg-warning text-white rounded-circle shadow d-flex align-items-center justify-content-center"
                          style={{ width: 42, height: 42 }}
                        >
                          <i className="ni ni-note-03" />
                        </div>
                      </div>
                    </div>
                    <p className="mt-2 mb-0 text-dark text-sm">
                      <span className="text-nowrap">Ses dosyası olan</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col xs="6" sm="6" lg="6" xl="3" className="d-flex">
                <Card
                  className="card-stats mb-3 mb-xl-0 flex-fill"
                  role="button"
                  tabIndex={0}
                  onClick={() => setFilter("video")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") setFilter("video");
                  }}
                  title="Videolu içerikleri filtrele"
                  style={{ cursor: "pointer" }}
                  aria-pressed={String(activeFilter || "all") === "video"}
                >
                  <CardBody className="py-3 px-3">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <CardTitle
                          tag="h6"
                          className="text-uppercase text-dark mb-1 text-truncate"
                        >
                          Videolu
                        </CardTitle>
                        <span className="h3 font-weight-bold mb-0 d-block text-truncate">
                          {stats.withVideo}
                        </span>
                      </div>
                      <div className="ml-auto flex-shrink-0" style={{ marginRight: -6 }}>
                        <div
                          className="icon icon-shape bg-info text-white rounded-circle shadow d-flex align-items-center justify-content-center"
                          style={{ width: 42, height: 42 }}
                        >
                          <i className="ni ni-button-play" />
                        </div>
                      </div>
                    </div>
                    <p className="mt-2 mb-0 text-dark text-sm">
                      <span className="text-nowrap">Video içerikli</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <div className="mt-3">
              <Carousel
                activeIndex={activeBannerIndex}
                next={nextBanner}
                previous={prevBanner}
                interval={5000}
              >
                <CarouselIndicators
                  items={ADMIN_HEADER_BANNER_ITEMS}
                  activeIndex={activeBannerIndex}
                  onClickHandler={goToBanner}
                />

                {ADMIN_HEADER_BANNER_ITEMS.map((item) => (
                  <CarouselItem
                    key={item.key}
                    onExiting={() => setIsBannerAnimating(true)}
                    onExited={() => setIsBannerAnimating(false)}
                  >
                    <div
                      className="rounded"
                      style={{
                        width: "100%",
                        maxWidth: 1500,
                        margin: "0 auto",
                        aspectRatio: "2 / 1",
                        overflow: "hidden",
                        cursor: "pointer",
                      }}
                      role="button"
                      tabIndex={0}
                      aria-label={`${item.altText} (büyüt)`}
                      onClick={() => openBannerPreview(item)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") openBannerPreview(item);
                      }}
                    >
                      <img
                        src={item.src}
                        alt={item.altText}
                        className="d-block w-100"
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    </div>
                  </CarouselItem>
                ))}

                <CarouselControl
                  direction="prev"
                  directionText="Previous"
                  onClickHandler={prevBanner}
                />
                <CarouselControl
                  direction="next"
                  directionText="Next"
                  onClickHandler={nextBanner}
                />
              </Carousel>
            </div>

            <div
              className="mt-3 d-flex flex-column flex-md-row justify-content-center"
              style={{ gap: 8 }}
            >
              <Button
                type="button"
                color="light"
                outline
                className="w-100 w-md-auto text-white border-white font-weight-bold"
                style={{ borderColor: "#fff", fontSize: 18, lineHeight: 1.2 }}
                onClick={onSharePage}
              >
                <i className="ni ni-send mr-2" aria-hidden="true" />
                Sayfayı Paylaş
              </Button>

              <Button
                tag={Link}
                to={`${APP_BASE}/auth/login`}
                color="light"
                outline
                className="w-100 w-md-auto text-white border-white font-weight-bold"
                style={{ borderColor: "#fff", fontSize: 18, lineHeight: 1.2 }}
              >
                <i className="ni ni-single-02 mr-2" aria-hidden="true" />
                Üye Ol/Giriş Yap
              </Button>
            </div>

            <div
              className="mt-3 text-center rounded p-2 mx-auto"
              style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffc107",
                maxWidth: 600,
              }}
            >
              <small className="font-weight-bold text-dark">
                Yeni efsane yazıp sonrasında inceleme yapabilir, dilerseniz üye olup daha fazla bilgi sahibi olabilirsiniz.
              </small>
            </div>
          </div>
        </Container>
      </div>

      <Modal
        isOpen={isBannerPreviewOpen}
        toggle={() => setIsBannerPreviewOpen(false)}
        size="lg"
        centered
      >
        <ModalBody className="p-0" style={{ position: "relative" }}>
          <button
            type="button"
            className="close"
            aria-label="Kapat"
            onClick={() => setIsBannerPreviewOpen(false)}
            style={{ position: "absolute", top: 8, right: 12, zIndex: 2 }}
          >
            <span aria-hidden="true">×</span>
          </button>
          <img
            src={bannerPreviewItem?.src}
            alt={bannerPreviewItem?.altText || "Banner"}
            className="img-fluid"
            style={{ width: "100%", maxHeight: "80vh", objectFit: "contain" }}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default Header;
